// src/components/common/TransactionPasswordModal.js
import React, { useState } from 'react';
import { authAPI } from '../../services/api';
import '../../styles/common/TransactionPasswordModal.css';

const TransactionPasswordModal = ({ onVerified, onClose, action }) => {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (password.length !== 6 || !/^\d+$/.test(password)) {
            setError('Please enter a valid 6-digit password');
            return;
        }
        
        setLoading(true);
        setError('');

        try {
            const response = await authAPI.verifyTransactionPassword({ transactionPassword: password });
            if (response.success) {
                // Store token temporarily (will expire in 5 minutes)
                localStorage.setItem('transactionToken', response.data.tempToken);
                onVerified(response.data.tempToken);
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Invalid transaction password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="transaction-modal-overlay" onClick={onClose}>
            <div className="transaction-modal" onClick={(e) => e.stopPropagation()}>
                <div className="transaction-modal-header">
                    <h2>Verify Transaction Password</h2>
                    <p>Please enter your 6-digit transaction password to {action}</p>
                </div>
                
                <div className="transaction-modal-body">
                    <div className="transaction-warning">
                        <span className="warning-icon">⚠️</span>
                        <p className="warning-text">This is a sensitive operation. Transaction password is required for security.</p>
                    </div>
                    
                    {error && (
                        <div className="transaction-error">
                            <span className="error-icon">❌</span>
                            <span>{error}</span>
                        </div>
                    )}
                    
                    <form onSubmit={handleSubmit}>
                        <div className="transaction-form-group">
                            <label>Transaction Password</label>
                            <input
                                type="password"
                                maxLength="6"
                                pattern="[0-9]{6}"
                                placeholder="••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value.replace(/\D/g, ''))}
                                className="transaction-password-input"
                                autoFocus
                                disabled={loading}
                            />
                        </div>
                        
                        <div className="transaction-modal-footer">
                            <button 
                                type="button" 
                                onClick={onClose} 
                                className="transaction-cancel-btn"
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button 
                                type="submit" 
                                className="transaction-verify-btn"
                                disabled={loading || password.length !== 6}
                            >
                                {loading ? <span className="transaction-loading"></span> : null}
                                {loading ? 'Verifying...' : 'Verify & Continue'}
                            </button>
                        </div>
                    </form>
                    
                    <p className="transaction-note">
                        Transaction password was provided to you on first login. 
                        If you forgot it, please contact your administrator.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TransactionPasswordModal;